export default __webpack_public_path__ + "static/media/Pelita Std-Regular.57da478c.otf";